/* product-pdp.js — PDP custom elements */

/* ── ATC price sync ──────────────────────────────────────────────────────── */
class AtcPriceSync extends HTMLElement {
  connectedCallback() {
    const section = document.getElementById(`Product--${this.dataset.sectionId}`);
    if (!section) return;

    const priceEl = section.querySelector('[data-price-wrapper] [data-product-price]')
      || section.querySelector('[data-product-price]');
    const atcBtn   = section.querySelector('[data-add-to-cart]');
    const atcPrice  = section.querySelector('[data-atc-price]');
    const atcSuffix = section.querySelector('.btn__price-suffix');
    if (!priceEl || !atcBtn || !atcPrice || !atcSuffix) return;

    const sync = () => {
      const available = !atcBtn.disabled;
      atcSuffix.hidden = !available;
      if (available) atcPrice.textContent = priceEl.textContent.trim();
    };

    new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
}

if (!customElements.get('atc-price-sync')) {
  customElements.define('atc-price-sync', AtcPriceSync);
}

/* ── Upsell carousel ─────────────────────────────────────────────────────── */
class UpsellCarousel extends HTMLElement {
  connectedCallback() {
    const id = this.dataset.carouselId;
    const init = () => {
      if (typeof Swiper === 'undefined') { setTimeout(init, 100); return; }
      new Swiper(`#${id}`, {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 500,
        loop: false,
        navigation: { prevEl: `#${id}-prev`, nextEl: `#${id}-next` },
        pagination: { el: `#${id}-pagination`, clickable: true },
      });
    };
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init)
      : init();
  }
}

if (!customElements.get('upsell-carousel')) {
  customElements.define('upsell-carousel', UpsellCarousel);
}

/* ── Gift wrap ───────────────────────────────────────────────────────────── */
class PdpGiftWrap extends HTMLElement {
  connectedCallback() {
    const sectionId    = this.dataset.sectionId;
    const productTitle = this.dataset.productTitle;

    document.addEventListener('theme:product:add', (evt) => {
      const btn = evt.detail?.button;
      if (!btn?.closest(`#Product--${sectionId}`)) return;

      const checkbox = document.getElementById(`pdp-gift-wrap-${sectionId}`);
      if (!checkbox?.checked) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(checkbox.dataset.giftWrapVariant),
          quantity: 1,
          properties: { '_for': productTitle },
        }),
      })
        .then(r => r.json())
        .then(() => {
          if (window.cart && typeof window.cart.getCart === 'function') {
            window.cart.getCart();
          }
        })
        .catch(err => console.error('Gift wrap add failed:', err));
    });
  }
}

if (!customElements.get('pdp-gift-wrap')) {
  customElements.define('pdp-gift-wrap', PdpGiftWrap);
}

/* ── USP list slider (mobile only) ────────────────────────────────────────── */
{
  const padTrack = (slider) => {
    if (slider.dataset.uspReady) return;
    const track = slider.querySelector('[data-usp-track]');
    const originals = [...track.children];
    let i = 0;
    while (track.children.length % 2 !== 0) {
      track.appendChild(originals[i % originals.length].cloneNode(true));
      i++;
    }
    slider.dataset.uspReady = '1';
  };

  const initAll = () => {
    if (window.innerWidth >= 750) return;
    document.querySelectorAll('[data-usp-slider]').forEach(padTrack);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('click', (e) => {
    if (window.innerWidth >= 750) return;

    const btn = e.target.closest('[data-usp-prev], [data-usp-next]');
    if (!btn) return;

    const slider = btn.closest('[data-usp-slider]');
    if (!slider) return;

    padTrack(slider);

    const viewport = slider.querySelector('.usp-slider__viewport');
    const track    = slider.querySelector('[data-usp-track]');
    const pages    = track.children.length / 2;
    const dir      = btn.hasAttribute('data-usp-prev') ? -1 : 1;
    let current    = parseInt(slider.dataset.uspPage || '0', 10);

    current = (current + dir + pages) % pages;
    slider.dataset.uspPage = current;

    const w = viewport.getBoundingClientRect().width;
    track.style.transform = `translateX(-${current * w}px)`;
  });
}
